import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import type { Complexity } from "@/shared/modal.api";
import { isObject } from "@/shared/utils/typeGuards";

export const kCraftRoute = "/craft";

export const kCraftEmphasisLength = 4;

export interface CraftRequestBody {
    audioKey: string;
    preset?: string;
    emphasis?: number[];
    complexity?: Complexity;
    naturalness?: number;
    uniformity?: number;
    transposition?: number;
    noteIdx?: number;
    seed?: number;
    deterministic?: boolean;
}

export const isCraftRequestBody = (value: unknown): value is CraftRequestBody => {
    if (!isObject(value)) {
        return false;
    }
    if (typeof value.audioKey !== "string" || value.audioKey === "") {
        return false;
    }
    if (value.preset !== undefined && typeof value.preset !== "string") {
        return false;
    }
    if (value.emphasis !== undefined) {
        if (!Array.isArray(value.emphasis) || value.emphasis.length !== kCraftEmphasisLength) {
            return false;
        }
        if (!value.emphasis.every((v) => typeof v === "number")) {
            return false;
        }
    }
    if (
        value.complexity !== undefined &&
        typeof value.complexity !== "number" &&
        value.complexity !== "auto"
    ) {
        return false;
    }
    if (value.naturalness !== undefined && typeof value.naturalness !== "number") {
        return false;
    }
    if (value.uniformity !== undefined && typeof value.uniformity !== "number") {
        return false;
    }
    if (value.transposition !== undefined && typeof value.transposition !== "number") {
        return false;
    }
    if (value.noteIdx !== undefined && typeof value.noteIdx !== "number") {
        return false;
    }
    if (value.seed !== undefined && typeof value.seed !== "number") {
        return false;
    }
    if (value.deterministic !== undefined && typeof value.deterministic !== "boolean") {
        return false;
    }
    return true;
};

export const kCraftEndpoint: ApiEndpoint<CraftRequestBody, DownloadUrlResponse> = {
    route: kCraftRoute,
    label: "Craft",
    source: "Modal",
    category: "SpliceGen",
    description:
        "Generates pitch-palette conditioned audio variations from an audio loop using the craft pipeline.",
    isRequestBody: isCraftRequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
